import { ReportExportApi } from './report-export-api';
import { useGipAltExportApi } from './useGipAltExportApi';
import { useGipExportApi } from './useGipExportApi';

export function useReportExportApi(reportType: string): ReportExportApi {
  const isGipAlt = reportType === 'AUDIT_GIP_ALTERNATIVE_REPORT';

  // Call both adapters' hooks unconditionally to preserve hook order
  const gip = useGipExportApi();
  const gipAlt = useGipAltExportApi();

  return isGipAlt ? gipAlt : gip;
}
